const isPromise = (x) =>
  x && typeof x.then === 'function' && typeof x.catch === 'function';

export default isPromise;
